import {
  AddIcon,
  Button,
  Card,
  CardHeader,
  Divider,
  EmptyState,
  MemberList,
  MemberListItem,
  MemberListItemSkeleton,
} from '@all-manager/design-system-v2';
import AddMemberModal from '../AddMemberModal/AddMemberModal';
import MemberMenuAction from '../MemberMenuAction/MemberMenuAction';
import useMembersCard from './useMembersCard';

type Props = {
  spaceId: string;
  isAdmin: boolean;
};

const SKELETON_ROWS = [0, 1, 2];

export default function MembersCard(props: Props) {
  const hook = useMembersCard({ spaceId: props.spaceId });

  return (
    <Card>
      <CardHeader
        title="Membres"
        subheader="Les personnes qui ont accès à cet espace et leur rôle."
        action={props.isAdmin ? (
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={hook.handleOpenAddMember}
          >
            Ajouter
          </Button>
        ) : undefined}
      />
      <Divider />

      {hook.isError ? (
        <EmptyState
          title="Membres indisponibles"
          subtitle="Le chargement a échoué. Rechargez la page pour réessayer."
        />
      ) : hook.isLoading ? (
        <MemberList aria-label="Membres" aria-busy>
          {SKELETON_ROWS.map((row) => <MemberListItemSkeleton key={row} />)}
        </MemberList>
      ) : hook.rows.length === 0 ? (
        <EmptyState
          title="Aucun membre"
          subtitle="Ajoutez les membres du conseil syndical et les copropriétaires qui doivent accéder à cet espace."
        />
      ) : (
        <MemberList aria-label="Membres">
          {hook.rows.map((row) => (
            <MemberListItem
              key={row.member.id}
              name={row.name}
              initials={row.initials}
              role={row.role}
              email={row.email}
              isCurrentUser={row.isCurrentUser}
              action={props.isAdmin && !row.isCurrentUser ? (
                <MemberMenuAction spaceId={props.spaceId} member={row.member} name={row.name} />
              ) : undefined}
            />
          ))}
        </MemberList>
      )}

      {hook.isAddMemberOpen ? (
        <AddMemberModal spaceId={props.spaceId} onClose={hook.handleCloseAddMember} />
      ) : null}
    </Card>
  );
}
